import { Group as TGroup } from "../api/group/Group";

export const GROUP_TITLE_FIELD = "title";

export const GroupTitle = (record: TGroup): string => {
  return record.title || record.id;
};
